export default "__VITE_ASSET__8c0fac0a__"